import React, { useState, useEffect } from 'react';
import api from '../api';
import './SkillsInput.css';

function SkillsInput({ selectedSkills, onSkillsChange }) {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (input.trim().length > 0) { // Trigger immediately on first letter
        try {
          const res = await api.get(`/public/skills/search?q=${input}`);
          setSuggestions(res.data);
          setShowDropdown(true);
        } catch (err) { console.error("Search error:", err); }
      } else {
        setSuggestions([]);
        setShowDropdown(false);
      }
    };

    const timeoutId = setTimeout(fetchSuggestions, 200); // Fast feedback
    return () => clearTimeout(timeoutId);
  }, [input]);

  const addSkill = (skillName) => {
    const name = skillName.trim();
    if (name && !selectedSkills.includes(name)) {
      onSkillsChange([...selectedSkills, name]);
    }
    setInput('');
    setSuggestions([]);
    setShowDropdown(false);
  };

  const removeSkill = (nameToRemove) => {
    onSkillsChange(selectedSkills.filter((s) => s !== nameToRemove));
  };

  return (
    <div className="skills-manager-container">
      <div className="skills-badge-list">
        {selectedSkills.map((skill) => (
          <div key={skill} className="skill-badge-item">
            {skill}
            <button type="button" className="skill-remove-btn" onClick={() => removeSkill(skill)}>&times;</button>
          </div>
        ))}
      </div>

      <div className="skills-input-rel">
        <input
          type="text"
          className="skills-main-input"
          placeholder="Type to add skills "
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addSkill(input);
            }
          }}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        />
        
        {showDropdown && (
          <ul className="skills-suggestion-dropdown">
            {suggestions.map((s) => (
              <li key={s.id} onClick={() => addSkill(s.name)}>{s.name}</li>
            ))}
            {input && !suggestions.find(s => s.name.toLowerCase() === input.toLowerCase()) && (
              <li className="add-custom-skill" onClick={() => addSkill(input)}>
                Add "<strong>{input}</strong>"
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}

export default SkillsInput;

